import styles from "./chatFileInner.module.scss";
import iconmusic from "../../../../styles/images/grid_music.svg";
import iconpdf from "../../../../styles/images/filepdf.svg";
import iconppt from "../../../../styles/images/fileppt.svg";
import iconword from "../../../../styles/images/fileword.svg";
import iconxls from "../../../../styles/images/fileexcel.svg";
import iconzip from "../../../../styles/images/filezip.svg";
import iconotherformat from "../../../../styles/images/otherformat.svg";
import iconarrow from "../../../../styles/images/viewarrow.svg";
import iconvideo from "../../../../styles/images/Mp4.svg";
import React, { useState } from "react";
import { mp3Formats, zipFormats, pdfFormats, wordFormats, pptFormats, excelFormats,videoFormat, getFileSize } from "../../../../base/utils";
import ChatAttachmentsOption from "../chatAttachmentOption";
import ChatAudioInner from "../chatAudioInner";
import ChatVideoPlayer from "../chatVideoPlayer";
import AllFilePreview from "../allFilePreview";

type replyMessageProps = {

  replyingMessage?: any;
  data?:any;
  groupdata?:any;
}
type fileMessageState = {
  isOpen: boolean;
  id: any;
};
export default function ChatFileInner({replyingMessage,data,groupdata}:replyMessageProps) {
  let dataRes = data && data !== undefined? data:"";
  const [fileState, setfileState] = useState<fileMessageState>({
    isOpen: false, id: ""
    
  });
  const [longText, setlongtext] = useState(0);
  const onclickgetId = (data: any) => {
    if(data.message?.body?.isCloudfiles) { window.open(data.message?.body?.filePath); }
    else {
      setfileState({ ...fileState, id: data.id });
      FilePreviewer();
    }
  };
  const FilePreviewer = () => {
    setfileState({ ...fileState, isOpen: !fileState.isOpen });
  };
  const readMoreChange = ()=>{
    setlongtext(1);
  }
  let mstext:any = data?.message?.body?.text;
  if(mstext && mstext !== ""){
    if (mstext?.length > 760 && longText === 0) {
      mstext = mstext.substring(0, 760) + "...";
    }
  }
  return (
    <>
    {fileState?.isOpen &&  <AllFilePreview isOpen={fileState?.isOpen}
        data={data}
        groupdata={groupdata}
        previewopen={onclickgetId} /> }
      <div className={styles.chatContent}>
     {dataRes ==="" && <div className={replyingMessage ? `${styles.filesChat} replyFilesType` : styles.filesChat } onClick={() => onclickgetId(data.id)}>
          <div className={styles.filesImage}>
            <img src={
              mp3Formats.indexOf(replyingMessage?.fileType) !== -1 ?iconmusic:
              zipFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconzip :
                pdfFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconpdf:
                  wordFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconword:
                    pptFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconppt:
                      excelFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconxls :iconotherformat}
            alt="filename" />
            </div>
          <div className={styles.filesDetails}>
            <span className={styles.fileName}>
              {replyingMessage?.fileName && replyingMessage?.fileName.substring(0,20)}</span>
            <span className={styles.fileDt}>File size:{getFileSize(replyingMessage?.filesize)}</span>
          </div>
            </div> }
           
      {dataRes !== "" &&  mp3Formats.indexOf(replyingMessage?.fileType) === -1  && videoFormat.indexOf(replyingMessage?.fileType) === -1  && <div className={replyingMessage ? `${styles.filesChat } replyFilesType` : styles.filesChat} onClick={() => {!replyingMessage?.isCloudfiles? onclickgetId(data.id) : window.open(replyingMessage.filePath) }    }>
          <div className={styles.filesImage}>
            <img src={
              zipFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconzip :
                pdfFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconpdf:
                  wordFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconword:
                    pptFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconppt:
                      excelFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconxls :iconotherformat}
            alt="filename" />
            </div>
          <div className={styles.filesDetails}>
          <p> {replyingMessage?.fileName && replyingMessage?.fileName.substring(0,20)}</p>
              <span className={styles.fileName}>
                {zipFormats.indexOf(replyingMessage?.fileType) !== -1 ? (
                  "ZIP"
                ) : pdfFormats.indexOf(replyingMessage?.fileType) !== -1 ? (
                  "PDF"
                ) : replyingMessage?.fileType &&
                  pptFormats.indexOf(replyingMessage?.fileType) !== -1 ? (
                  "PPT"
                ) : excelFormats.indexOf(replyingMessage?.fileType) !== -1 ? (replyingMessage?.fileType==='text/csv'?
                "CSV":"XLS"
                ) : wordFormats.indexOf(replyingMessage?.fileType) !== -1 ? (
                  "WORD"
                ) : (
                  "OTHER"
                ) }
                  </span>
                •
              <span className={styles.fileDt}>{getFileSize(replyingMessage?.filesize)}</span>
              { replyingMessage?.isCloudfiles  && <span className={styles.fileDt}>{replyingMessage?.filePath.includes('https://app.box.com') ? 'File from Box'  : " File from Drive" }</span>}

            </div>
            {replyingMessage?.isCloudfiles && <div className={styles.forarrowview}>
                                        <img src={iconarrow} alt=""/>
                                      </div>}
          {/* <div className={styles.attachmentHover} id={"hover"+data?.id}>
            <ChatAttachmentsOption data={data} fromFiles={false}  previewopen={onclickgetId} hoverdata={data}/></div>
            */}
             </div> }
           {mp3Formats.indexOf(replyingMessage?.fileType) === -1 && videoFormat.indexOf(replyingMessage?.fileType) === -1 &&  <div className="textContent">
                     {data?.message?.body?.text !== ""  && mp3Formats.indexOf(replyingMessage?.fileType) === -1 && videoFormat.indexOf(replyingMessage?.fileType) === -1  && 
         <span className={`textmsg ${styles.messageContent}`}>{data?.message?.body?.text}</span>}
                  <span className="width75"></span>
                </div>}
             {dataRes !== "" && mp3Formats.indexOf(replyingMessage?.fileType) !== -1  && !replyingMessage?.isCloudfiles &&
             <>
             <ChatAudioInner data={data} userDetails = {data?.fromcaller_details}/>
            <div className="textContent">
            {data?.message?.body?.text !== "" && 
            <span className={`textmsg ${styles.messageContent}`}>
             <span  dangerouslySetInnerHTML={{ __html: (mstext) }}></span>
                      {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}</span>}
                  <span className="width75"></span>
                </div>
             </>
             }

                
             {dataRes !== "" && videoFormat.indexOf(replyingMessage?.fileType) !== -1  && !replyingMessage?.isCloudfiles &&
              <>
              <ChatVideoPlayer  data={data} multiData={data}></ChatVideoPlayer>
              {data?.message?.body?.text !== "" &&<div className="textContent">
              <span className={`textmsg ${styles.messageContent}`}>
              <span  dangerouslySetInnerHTML={{ __html: (mstext) }}></span>
                      {mstext?.length > 760 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}</span>
           
              <span className="width75"></span>
            </div>}
         </>
            }


            {
              dataRes !== '' && (videoFormat.indexOf(replyingMessage?.fileType) !== -1 || mp3Formats.indexOf(replyingMessage?.fileType) !== -1) && replyingMessage?.isCloudfiles &&
              <>
               <div className={styles.filesChat} onClick={()=> {window.open(replyingMessage?.filePath)}}>
          <div className={styles.filesImage}>
            <img src={
               mp3Formats.indexOf(replyingMessage?.fileType) !== -1 ?iconmusic :
               videoFormat.indexOf(replyingMessage?.fileType) !== -1 ? iconvideo :
               iconotherformat}
            alt="filename" />
            </div>
          <div className={styles.filesDetails}>
          <p> {replyingMessage?.fileName && replyingMessage?.fileName.substring(0,20)}</p>
              <span className={styles.fileName}>
                {mp3Formats.indexOf(replyingMessage?.fileType) !== -1 ? (
                  "AUDIO"
                ) : videoFormat.indexOf(replyingMessage?.fileType) !== -1 ? (
                  "VIDEO"
                ): (
                  "OTHER"
                ) }
                  </span>
                •
              <span className={styles.fileDt}>{getFileSize(replyingMessage?.filesize)}</span>
              { replyingMessage?.isCloudfiles  && <span className={styles.fileDt}>{replyingMessage?.filePath.includes('https://app.box.com') ? 'File from Box'  : " File from Drive" }</span>}

            </div>
            {replyingMessage?.isCloudfiles && <div className={styles.forarrowview}>
                                        <img src={iconarrow} alt=""/>
                                      </div>}
       </div>
              </>
            }
      </div>
    </>
  );
};
